import Model from 'src/app/common/model';

export default class WaterTypeModel extends Model {
  name: string;
  abbreviation?: string;
  description?: string;

  constructor() {
    super();
  }
}
